import React, { useState, useCallback, useRef } from 'react';
import { Modal, Button } from '../ui-kit';
import { Provider } from 'react-redux';
import store from '../../state';
import PersonnelTransferForm from './PersonnelTransferForm';

// To test
/*
include FactoryBot::Syntax::Methods

station1 = create(:station, :in_region_hierarchy, name: 'Station 1')
station2 = create(:station, name: 'Station 2', parent_group: station1.parent_group)

membership = create(:active_membership, group: station1)

create(:absence_request_for_duty, owner: membership, start_time: Time.zone.now, end_time: 1.week.from_now)

report = create(:general_activity_report, start_time: Time.zone.now, end_time: 1.week.from_now, groups: [station1])
create(:general_attendance, activity_report: report, membership: membership)

scheduler = create(:user)
create(:active_membership, group: station1, user: scheduler).tap(&:make_scheduler!)
create(:active_membership, group: station2, user: scheduler).tap(&:make_scheduler!)

Launchy.open("http://localhost:3000/admin/users/#{scheduler.id}/become")
sleep 2
Launchy.open("http://localhost:3000/users/#{membership.user_id}/personnel_transfers")
*/

const PersonnelTransferModal = props => {
  const [isSaving, setIsSaving] = useState(false);
  const saveCallback = useRef(null);
  const saveAsDraftCallback = useRef(null);

  const registerSaveCallback = useCallback(callback => {
    saveCallback.current = callback;
  }, []);

  const registerSaveAsDraftCallback = useCallback(callback => {
    saveAsDraftCallback.current = callback;
  }, []);

  const save = async callback => {
    if (!callback) return;

    setIsSaving(true);
    try {
      const { success, id } = await callback();
      if (success) {
        // redirect to the personnel transfer
        location.href = `/personnel_transfers/${id}`;
      } else {
        setIsSaving(false);
      }
    } catch (error) {
      console.error('Save failed:', error);
      setIsSaving(false);
    }
  };

  return (
    <Modal size="lg" show={true} onHide={props.onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{I18n.t('schedules.exchanges.personnel_transfer.modal_title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ overflowY: 'visible' }}>
        <Provider store={store}>
          <PersonnelTransferForm
            {...props}
            registerSaveCallback={registerSaveCallback}
            registerSaveAsDraftCallback={registerSaveAsDraftCallback}
          />
        </Provider>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>
          {I18n.t('cancel')}
        </Button>
        <Button onClick={() => save(saveAsDraftCallback.current)} disabled={isSaving} variant="outline-primary">
          {isSaving ? I18n.t('saving') : I18n.t('save_as_draft')}
        </Button>
        <Button onClick={() => save(saveCallback.current)} disabled={isSaving} variant="success">
          {isSaving ? I18n.t('saving') : I18n.t('process')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PersonnelTransferModal;
